import { ReactElement, useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { ListingFunctionType } from '@/common/analytics/gtm/types';
import MasonryFeedsSelector from '@/common/components/MasonryFeed/MasonryFeedsSelector';
import {
  areAllFeedsHidden,
  createFeedContentComponent,
} from '@/common/components/MasonryFeed/MasonryFeedsUtils';
import { ComponentMetadata } from '@/common/components/types';
import { GalleryItem } from 'generatedBfw/static';

import styles from './masonryFeed.module.scss';
import { MasonryFeedSkeleton } from './MasonryFeedSkeleton/MasonryFeedSkeleton';

export const MIN_NUM_OF_POSTERS_FOR_FEED = 3;

export interface Feed {
  name: string;
  items: GalleryItem[];
  shouldBeShown: boolean;
  masonryListingFunction: ListingFunctionType;
  infiniteScroll?: boolean;
  redirectButton?: () => ReactElement;
  overrideGridComponent?: () => ReactElement;
}

interface MasonryFeedsProps {
  feeds: Feed[];
  metadata: ComponentMetadata;
}

export const MasonryFeeds = ({ feeds, metadata }: MasonryFeedsProps) => {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    // reset feeds and tabs upon navigation
    setActiveTab(0);
  }, [router.asPath]);

  if (feeds.length === 0 || areAllFeedsHidden(feeds)) return <MasonryFeedSkeleton />;

  const feedContents = feeds
    .filter((feed) => feed.shouldBeShown)
    .map((feed) => createFeedContentComponent(feed, metadata));

  return (
    <div className={styles.masonryFeedWrapper} data-testid="masonry-feed-container">
      <MasonryFeedsSelector
        activeTab={activeTab}
        feedContents={feedContents}
        handleFeedChange={setActiveTab}
      />
    </div>
  );
};
